export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.$i18n.defaultLocale = navigator.language.startsWith("sv") ? "sv" : "en";
});
